import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { INVITE_TYPE } from "../../../../../constants/InviteConstants";
import SendSMSAndWhatsApp from "../SendSMSAndWhatsApp";
import { WHATSAPP_INVITATION_PREVIEW_TEXT } from "../../../../../constants/Constants";
import { useSelector } from "react-redux";

const WhatsAppTab = (props) => {
    const { isDoneBtnVisible, handleCloseModal, isSentBtnVisible, handleSendInvite, inviteUrl, mobileNumberRef } = props;

    const { selectedWhatsAppCountry } = useSelector((state) => state.inviteParticipant);
    const { privacyPolicyData } = useSelector((state) => state.onLoadData);

    const [whatsAppTemplate, setWhatsAppTemplate] = useState("");

    useEffect(() => {
        if (privacyPolicyData) {
            const whatsAppText = WHATSAPP_INVITATION_PREVIEW_TEXT.replace("<company_name>", privacyPolicyData?.domainName);
            setWhatsAppTemplate(whatsAppText);
        }
    }, [privacyPolicyData]);

    return (
        <SendSMSAndWhatsApp
            type={INVITE_TYPE.WhatsApp}
            id='invite-whatsapp'
            testId='invite-whatsapp-tab'
            defaultCountryCode={selectedWhatsAppCountry.iso2}
            whatsAppTemplate={whatsAppTemplate}
            handleSendInvite={handleSendInvite}
            handleCloseModal={handleCloseModal}
            isSentBtnVisible={isSentBtnVisible}
            isDoneBtnVisible={isDoneBtnVisible}
            whatsAppInviteUrl={inviteUrl}
            selectedCountry={selectedWhatsAppCountry}
            mobileNumberRef={mobileNumberRef}
        />
    );
};

WhatsAppTab.propTypes = {
    inviteUrl: PropTypes.string,
    handleSendInvite: PropTypes.func,
    isDoneBtnVisible: PropTypes.bool,
    handleCloseModal: PropTypes.func,
    isSentBtnVisible: PropTypes.bool,
    mobileNumberRef: PropTypes.any,
};

export default WhatsAppTab;
